import { render, staticRenderFns } from "./DisputesTable.vue?vue&type=template&id=0ec1fb2d"
import script from "./DisputesTable.vue?vue&type=script&lang=js"
export * from "./DisputesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports